function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35C9BC"
    },
    d: "M23.8446312,44.1823235c0,22.5073662,40.5818672,84.5449677,40.5818672,84.5449677 S105,66.6896896,105,44.1823235c0-23.4272938-18.1990814-42.4915276-40.5735016-42.4915276 S23.8446312,20.7550297,23.8446312,44.1823235z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AAE5DE"
    },
    cx: 64.4223175,
    cy: 43.2926521,
    r: 30.5987434
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_148_",
    style: {
      fill: "#35C9BC"
    },
    points: "46.2640228,37.1797142 58.309433,37.1797142 58.309433,25.1343212  70.5352936,25.1343212 70.5352936,37.1797142 82.5806122,37.1797142 82.5806122,49.4056282 70.5352936,49.4056282  70.5352936,61.4509811 58.309433,61.4509811 58.309433,49.4056282 46.2640228,49.4056282  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M64.4222946,12.6939087c-16.899231,0-30.5987396,13.6995296-30.5987396,30.5987625 c0,16.8991928,13.6995087,30.5987015,30.5987396,30.5987015c16.8992538,0,30.5987625-13.6995087,30.5987625-30.5987015 C95.0210571,26.3934383,81.3215485,12.6939087,64.4222946,12.6939087z M64.4222946,70.5444107 c-15.0266685,0-27.2517776-12.2250519-27.2517776-27.2517395s12.2251091-27.2518005,27.2517776-27.2518005 c15.0266876,0,27.2518005,12.225111,27.2518005,27.2518005S79.4489822,70.5444107,64.4222946,70.5444107z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalpoint);
export default __webpack_public_path__ + "static/media/medicalpoint.6167f3d9fd3ee7c34813b36d48ae07aa.svg";
export { ForwardRef as ReactComponent };